import { oc } from "@orpc/contract";
import { openapi } from "@orpc/openapi";
import { z } from "zod";
import { errors, paxRoute, sessionRequired } from "../../common";
import { playerOrStaff } from "./balances";
import { OpenHoldsResponse, UserParams } from "./schemas";

export const listPlayerOpenHolds = oc
  .meta(
    paxRoute({ auth: playerOrStaff, minimumTier: null, cost: "read" }),
    openapi({
      method: "GET",
      path: "/api/accounting/v1alpha1/players/{userId}/open-holds",
      operationId: "accounting.players.openHolds.list",
      summary: "List a player's open holds.",
      description:
        "Returns one player's ordinary holds whose deadline is still ahead, and the total they reserve.",
      inputStructure: "detailed",
      successDescription: "The player's open holds.",
    }),
  )
  .errors({ ...errors.badRequest, ...sessionRequired, ...errors.forbidden })
  .input(z.object({ params: UserParams }))
  .output(OpenHoldsResponse);
